import downloadYaml from './downloadYaml';
import {Exporter} from 'react-admin';

//const yamlExporter = (data, _, __, resource) => null;

// Added async as type expects promise. Gets rid of: Type error: Type 'void' is not assignable to type 'Promise<void>'.  TS2322
// Backend now returns { name: string, data: string } matching Conversions pattern
const yamlExporter: Exporter = async (data: any, _, __, resource) => {
  // Use the name from backend response, fallback to resource name
  const filename = data?.name || resource || 'export';
  // data.data contains the YAML content (matching Conversions pattern)
  const yamlContent = data?.data || data;

  downloadYaml(yamlContent, filename);
}

export default yamlExporter;
